import * as React from "react";
import { forwardRef } from "react";
const SvgIconCircularCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 3a9 9 0 1 0 9 9 7.9 7.9 0 0 0-.476-2.834l-1.125 1.1A7 7 0 0 1 19.615 12 7.615 7.615 0 1 1 12 4.385a7.4 7.4 0 0 1 5.257 2.142l.974-.974A8.78 8.78 0 0 0 12 3m7.81 2.964L12 13.774 9.036 10.81l-1 1 3.464 3.457.5.476.5-.476 8.308-8.308z", transform: "translate(-3 -3)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconCircularCheck);
export { ForwardRef as ReactComponent };
